<div class="">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 header-titles">
      <div *ngIf="!listOfBus">
        <mat-spinner></mat-spinner>
      </div>
      <section *ngIf="listOfBus">
        <div class="example-button-row">
          <h4 class="selection-subtitle">Seleccione una linea.</h4>

          <button *ngFor="let bus of listOfBus" [class]="'bus-button'" [style]="
              'border: 2px solid #' + bus.route_color + ';' + 'color: ' + '#353535' + ';'
            " mat-stroked-button color="primary" (click)="getBusRoute(bus)">
            <span class="number-bus-header" [style]="'background-color: #' + bus.route_color + ';'">
              {{ bus.route_short_name }}
            </span>
            <label>
              {{ bus.route_long_name }}
            </label>
          </button>
        </div>
      </section>
    </div>
  </div>
</div>
